import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import SignUp from './pages/SignUp';
import ThankYou from './pages/ThankYou';
import './App.css';

const ScrollToHash = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({ top: 0 });
      return;
    }

    window.setTimeout(() => {
      document.getElementById(location.hash.slice(1))?.scrollIntoView({ block: 'start' });
    }, 0);
  }, [location.pathname, location.hash]);

  return null;
};

const AppShell = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <div className={`App ${isHomePage ? 'App-home' : ''}`}>
      <ScrollToHash />
      <Header />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Navigate to="/#contact" replace />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/signup/thank-you" element={<ThankYou />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export const AppContent = () => (
  <LanguageProvider>
    <AppShell />
  </LanguageProvider>
);

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
